import { IDocument } from "types/backend_models/documents/IDocument";
import { message } from "antd";
import { getDataActionConstants } from "redux/actions/dataActions/dataActionConstants";

// const correctBlobType = 'application/pdf';
const docBlobType = 'application/msword'; 
const docxBlobType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const pdfBlobType = 'application/pdf';

export function downloadDocument(doc: IDocument)
{
	// console.log('document', doc);
	const constants = getDataActionConstants();
	const requestInit: RequestInit = {
		headers: constants.headers
	}

	fetch(`${constants.serverRoot}/api/customer/documents/${doc.id}/file`, requestInit) 
		.then((resp: Response) =>
		{
			// console.log('document response', resp);
			if (resp.status === 200) {
				return resp.blob();
			} else {
				throw Error(`Document server error. Status:${resp.status}`);
			}
		}).then((blob: Blob | undefined) =>
		{
			if (blob) {
				console.log(blob)
				const url = window.URL.createObjectURL(blob);
				console.log(url)
				
				if (blob.type === pdfBlobType) {
					const w = window.open(url, '_blank') || {document: {title: ''}}
					setTimeout(() => w.document.title = doc.originalFileName, 1000)
				} 
				else if(blob.type === docBlobType || blob.type === docxBlobType) {
					const a = document.createElement('a');
					a.style.display = 'none';
					a.href = url;
					a.target = '_blank'
					a.download = doc.originalFileName;
					document.body.appendChild(a);
					a.click();
				}
				
				else {
					throw Error(`Document server error. Wrong blob type. Blob:${blob}`);
				}
			} else {
				throw Error('Document server error. Response.blob() returned undefined.')
			}
		})
		// .then((url: string) => {
		// 	console.log(url);

		// 	const w = window.open(url, '_blank') || {document: {title: ''}}
        // 	setTimeout(() => w.document.title = doc.originalFileName, 1000)
		// })
		.catch((error: Error) =>
		{
			console.error(error);
			message.error('Something went wrong while downloading the document. Please try again later', 3);
		});
}

			// const a = document.createElement('a');
			// a.style.display = 'none';
			// a.href = url;
			// a.target = '_blank'
			// a.download = doc.originalFileName;
			// document.body.appendChild(a);
			// a.click();
			// window.URL.revokeObjectURL(url);
			// document.body.removeChild(a);